import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl';
import Toast from '../../helpers/Toast';
import { GetDebtHoursDTO } from '../../models/Assistance/GetDebtHoursDTO'
import { GetPaginatedDebtHoursDTO } from '../../models/Assistance/GetPaginatedDebtHoursDTO';
import { AssistanceService } from '../../services/AssistanceService';
import TableComponent from '../TableComponent';

type ExecutionsDebtHoursTableProps = {
    assistanceId: number;
    reload: boolean;
}

function ExecutionsDebtHoursTable({ assistanceId, reload }: ExecutionsDebtHoursTableProps) {
    const assistanceService = new AssistanceService();
    const [data, setData] = useState<GetDebtHoursDTO[]>([]);
    const pageSizes: number[] = [5, 15, 30];
    const [pageSize, setPageSize] = useState<number>(pageSizes[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [goToPage, setGoToPage] = useState<number>();
    const [pageCount, setPageCount] = useState(1);

    const columns = React.useMemo(
        () => [
            {
                Header: "Data",
                accessor: "dateString",
                width: 30,
            },
            {
                Header: "Artigo",
                accessor: "article",
                width: 30,
            },
            {
                Header: "Horas",
                accessor: "debtHours",
                width: 30,
            },
        ],
        [],
    );

    const fetchData = async (page: number, pageSize: number) => {
        var data: GetPaginatedDebtHoursDTO = {
            assistanceId: assistanceId,
            currentPage: page,
            pageSize: pageSize
        }

        setIsLoading(true);
        var response = await assistanceService.GetDebtHours(data);


        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }

        setData(response.items);
        setIsLoading(false);
        setPageCount(response.totalPages);
        setPageSize(pageSize);
        setCurrentPage(page);
        setGoToPage(0);
    }

    useEffect(() => {

        if (reload) {
            fetchData(currentPage, pageSize);
        }

    }, [reload]);

    return (
        <div>
            <TableComponent
                columns={columns}
                data={data}
                goToPage={goToPage}
                initialPage={currentPage}
                pageCount={pageCount}
                initialPageSize={pageSize}
                pageSizes={pageSizes}
                manualPagination={true}
                loading={isLoading}
                fetchData={fetchData}
                initialSortBy={[]}
                disableSortBy={true}
            />
        </div>
    )
}

export default ExecutionsDebtHoursTable